import React from 'react';
import { LoadingButton as MuiButton } from '@mui/lab';
import styled, { useTheme } from 'styled-components';
import { makeStyles } from '@mui/styles';

type Props = {
  type?: 'submit' | 'reset' | 'button';
  id?: string;
  width?: any;
  loading?: boolean;
  color?:
    | 'inherit'
    | 'success'
    | 'error'
    | 'info'
    | 'warning'
    | 'primary'
    | 'secondary'
    | undefined;
  variant?: 'contained' | 'outlined' | 'text';
  fullWidth?: boolean;
  customHeight?: string;
  children: React.ReactNode;
  onClick?:
    | ((event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void)
    | undefined;
  style?: React.CSSProperties;
  className?: string;
  disabled?: boolean;
  dataTestId?: string;
  startIcon?: React.ReactNode;
  loadingPosition?: 'center' | 'start' | 'end' | undefined;
};

const Button = styled(MuiButton)<Props>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${props => props.width ?? 'auto'};
  height: ${props => props?.customHeight ?? 'auto'};
  text-align: center;
  outline: none;
  border-radius: 4px;
  color: ${props => props.theme.solidWhite};
  opacity: ${props => (props.disabled ? '0.5' : '1')};
  background: ${props => props.theme.main};
  background-color: ${props => props.theme.main};
  border: 1px solid ${props => props.theme.main};

  &:hover {
    cursor: pointer;
  }
  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
  .MuiLoadingButton-loadingIndicator {
    color: ${props => props.theme.solidWhite};
    position: unset;
  }
`;

const useStyles = makeStyles({
  root: {
    '&.MuiButtonBase-root': {
      '&.MuiLoadingButton-loading': {
        color: (theme: any) => theme?.solidWhite,
        '&.MuiLoadingButton-loadingIndicator': {
          position: 'unset',
          color: (theme: any) => theme?.solidWhite,
        },
      },
    },
  },
});

function PrimaryButton({
  width = 'auto',
  type = 'button',
  variant = 'contained',
  fullWidth = false,
  customHeight,
  children,
  className,
  style,
  onClick,
  disabled = false,
  dataTestId = undefined,
  ...rest
}: Props): React.JSX.Element {
  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <Button
      type={type}
      width={width}
      variant={variant}
      disabled={disabled}
      style={style}
      onClick={onClick}
      className={`${classes?.root} ${className}`}
      fullWidth={fullWidth}
      customHeight={customHeight}
      data-cy={dataTestId}
      {...rest}
    >
      {children}
    </Button>
  );
}

export default PrimaryButton;
